class Logo {
  id = null

  name = ''

  original_name = ''

  event_id = null

  created_at = null

  updated_at = null

  link = ''

  constructor(options = {}) {
    Object.assign(this, options)
  }

  // let file = (new Logo).fill({ name: "whatever" });
  fill(options) {
    return Object.assign(this, options)
  }
}

export default Logo
